import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ShotApprovalStatus } from 'src/app/components/company/models/new/shot'; 

@Component({
	selector: 'bt-approve-order-note',
	standalone: false,
	templateUrl: './approve-order-note.html',
	styleUrl: './approve-order-note.scss'
})
export class ApproveOrderNoteComponent {
	readonly #dialogRef = inject(MatDialogRef<ApproveOrderNoteComponent>);
	readonly data = inject<any>(MAT_DIALOG_DATA);
	ShotApprovalStatus = ShotApprovalStatus;

	note = '';

	close() {
		this.#dialogRef.close();
	}

	confirm() {
		this.#dialogRef.close(this.note);
	}
}
